import { adjustUrl } from '@d-shared/forms/forms';
import ErrorsHelper from '@d-shared/helpers/errors-helper/errors-helper';

export default {
  data: () => ({
    isLoading: false,
    isProcessing: false,
  }),

  methods: {
    blurUrlEntry(fieldName, shouldTouchField = false) {
      if (typeof this[fieldName] === 'undefined') {
        return false;
      }

      this[fieldName] = adjustUrl(this[fieldName]);

      if (shouldTouchField && this.$v) {
        this.$v[fieldName].$touch();
      }
      return true;
    },

    forceNumberInput(fieldName) {
      if (typeof this[fieldName] === 'undefined') {
        return false;
      }

      let fieldValue = this[fieldName].toString().replace(/\D/g, '');
      fieldValue = parseInt(fieldValue);

      if (isNaN(fieldValue)) {
        this[fieldName] = '';
        return false;
      }

      this[fieldName] = fieldValue;
      return true;
    },

    getValidationMessage($vField) {
      return ErrorsHelper.getValidationMessage($vField);
    },

    touchField(fieldName) {
      if (typeof this.$v[fieldName] === 'undefined') {
        return false;
      }

      if (this.$v[fieldName].$params.integer) {
        this.forceNumberInput(fieldName);
      }

      this.$v[fieldName].$touch();
      return true;
    },
  },
};
